import {
  createWizardSlice,
  initState as wizardInitialState,
} from '../../../features/Wizard/slice';

export const SignUpSlice = createWizardSlice('verifyEmail', undefined, {
  clearAll: () => wizardInitialState,
});

export const SignUpSliceReducer = SignUpSlice.reducer;
